import { useState, useEffect } from 'react';
import moment from 'moment';
import FieldService from '@Helpers/URLHelpers/FieldService';
import '@Partials/_ComStyles.scss';
import './UserIssueRow.scss';

export default function UserIssueRow(props) {

    const [ticket, setTicket] = useState({});
    const [, setAdminFieldList] = useState([]);
    let fieldFilter = {
        projectIdList: [],
        tableType: 'kaiziqResolveConnection',
        filterAttribute1List: []
    };
    const fieldService = new FieldService();
    const className = 'userIssueRow';

    useEffect(() => {
        setTicket(props.ticket);
        renderData();
    }, [props]);

    const renderData = async() => {
        let adminFilter = fieldFilter;
        adminFilter.filterAttribute1List = ['admin'];
        adminFilter.projectIdList = [props.ticket?.projectId];
        adminFilter.tableId = props.ticket?.kaiziqResolveConnectionId;
        let filter = {
            fieldFilter: adminFilter
        }
        let adminFieldListObj = await fieldService.getListFiltered(filter);
        if(!!adminFieldListObj.body) {
            adminFieldListObj = JSON.parse(adminFieldListObj.body);
            setAdminFieldList(adminFieldListObj?.result);
        }
    }

    const handleClick = () => {
        props?.handleTicketClick(props?.ticket);
    }

    return (
        <div className={className + ' width-wfa'} onClick={handleClick}>
            <div className={className + '__inner flex-column-flex-start-1vh-fap width-wfa'}>
                <div className={className + '__inner__header flex-row-center-space-between width-wfa'}>
                    <div className={className + '__inner__header__left flex-row-center-1vw-gap'}>
                        <div className={className + '__inner__header__left__tag standard-tag'}>
                            {ticket?.ticketId ?? 'N/A'}
                        </div>
                        <div className={className + '__inner__header__left__status text-overflow-ellipsis capitalize flex-row-center-0p5vw-gap'}>
                            <div className={className + '__inner__header__left__status__indicator indicator-box capitalize'}
                                style={{background: ticket?.statusColor || '#2784B9'}}/>
                            <div className={className + '__inner__header__left__status__text text-overflow-ellipsis capitalize'}>
                                {ticket?.statusTitle || 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div className={className + '__inner__header__right flex-row-center-1vw-gap'}>
                        <div className={className + '__inner__header__right__project flex-row-center-0p5vw-gap'}>
                            <div className={className + '__inner__header__right__project__tag standard-tag'}>
                                {ticket?.projectTag}
                            </div>
                            <div className={className + '__inner__header__right__project__name'}>
                                {ticket?.projectName}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={className + '__inner__title'}>
                    {ticket?.ticketTitle || 'No title provided'}
                </div>
                <div className={className + '__inner__footer flex-row-center-space-between width-wfa'}>
                    <div className={className + '__inner__footer__left flex-row-center-1vw-gap'}>
                        <div className={className + '__inner__footer__left__creator flex-row-center-0p5vw-gap'}>
                            <div className={className + '__inner__footer__left__creator__avatar'}>
                                {ticket?.createdByFullName?.charAt(0)?.toUpperCase() || '?'}
                            </div>
                            <div className={className + '__inner__footer__left__creator__info flex-column-flex-start'}>
                                <div className={className + '__inner__footer__left__creator__info__name'}>
                                    {ticket?.createdByFullName || 'Unknown'}
                                </div>
                                <div className={className + '__inner__footer__left__creator__info__label'}>
                                    Reporter
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={className + '__inner__footer__right flex-row-center-1vw-gap'}>
                        <div className={className + '__inner__footer__right__updated grey-text flex-row-center sm-text '}>
                            <div className={className + '__inner__footer__right__updated__t1'}>
                                Updated &nbsp;
                            </div>
                            <div className={className + '__inner__footer__right__updated__value no-wrap'}>
                                {moment(new Date(ticket?.modifiedTimeStamp),'DD-MM-YYYY').fromNow()}
                            </div>
                        </div>
                        <div className={className + '__inner__footer__right__created grey-text flex-row-center sm-text'}>
                            <div className={className + '__inner__footer__right__created__t1'}>
                                Created &nbsp;
                            </div>
                            <div className={className + '__inner__footer__right__created__value no-wrap'}>
                                {moment(new Date(ticket?.createTimeStamp),'DD-MM-YYYY').fromNow()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
